const colorMapper = (id) => {
  switch (id) {
    case "2":
      return "westAfrika";
    case "3":
      return "nederland";
    case "4":
      return "spaans";
    case "5":
      return "admiraliteit";
    case "6":
      return "kaper";
    case "7":
      return "verkenning";
    case "8":
      return "europa";
    default:
      return "driehoek";
  }
};

export default colorMapper;
